import { Component } from "react";

export class SinDatos extends Component {
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <img src="/actualizacion-info.cf.svg" alt="Actualizando la información" width="450px" />
                        <div class="cont-text">
                            <h4>Estamos actualizando esta información.</h4>
                            <p>Intente nuevamente mas tarde.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}